import { render, staticRenderFns } from "./RetencionUpload.vue?vue&type=template&id=bb88e700&scoped=true"
import script from "./RetencionUpload.vue?vue&type=script&lang=js"
export * from "./RetencionUpload.vue?vue&type=script&lang=js"
import style0 from "./RetencionUpload.vue?vue&type=style&index=0&id=bb88e700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb88e700",
  null
  
)

export default component.exports